import { createSlice } from '@reduxjs/toolkit';
import { RelationEntity } from '@interpals/api-web';

import { blockUser, unblockUser } from 'redux/profile/actions';

import { getBlockedUsers, getBlockedUsersCount } from './actions';
import { PAGE_LIMIT } from './actions';

export interface BlockedState {
    data: RelationEntity[];
    hasMore: boolean;
    isLoading: boolean;
    totalBlocked: number;
}

const initialState: BlockedState = {
    data: [],
    hasMore: true,
    isLoading: false,
    totalBlocked: 0,
};

const blockedSlice = createSlice({
    name: 'blocked',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getBlockedUsers.fulfilled, (state, { payload }) => {
            state.data = state.data ? [...state.data, ...payload] : payload;
            state.hasMore = payload.length === PAGE_LIMIT;
            state.isLoading = false;
        });
        builder.addCase(getBlockedUsers.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getBlockedUsersCount.fulfilled, (state, { payload }) => {
            state.totalBlocked = payload.total;
        });
        builder.addCase(blockUser.fulfilled, (state, { payload }) => {
            state.data = [payload, ...state.data];
            state.totalBlocked = state.totalBlocked + 1;
        });
        builder.addCase(unblockUser.fulfilled, (state, { payload }) => {
            state.data = state.data.filter((item) => item.target_id !== payload.target_id);
            state.totalBlocked = state.totalBlocked - 1;
        });
    },
});

export default blockedSlice.reducer;
